import { Component, Element, Prop, h, State, forceUpdate, Event, EventEmitter } from '@stencil/core';
import { Trouble, Zone } from './area-interface';
import map from 'lodash-es/map';
import forOwn from 'lodash-es/forOwn';
import sortBy from 'lodash-es/sortBy';
import uniq from 'lodash-es/uniq';
import groupBy from 'lodash-es/groupBy';
import { Color } from '../../interface';

@Component({
  tag: 'lar-area-bypass',
  styleUrl: 'area.scss',
  shadow: true,
})
export class AreaBypass {
  @Element() el!: HTMLLarAreaElement;

  @Prop() color?: Color;
  @Prop() zones: string;
  @Prop() troubles: string;
  @Prop() modal: HTMLLarModalElement;

  @Event() output!: EventEmitter;

  @State() bypassZones: string[] = [];
  private zonesList: Zone[] = [];
  private troubleList: Trouble[] = [];

  private togglePyPassZone(zone: any) {
    const bypassedIndex = this.bypassZones.indexOf(zone.id);
    if (bypassedIndex > -1) {
      this.bypassZones.splice(bypassedIndex, 1);
    } else {
      this.bypassZones.push(zone.id);
    }
    forceUpdate(this.el);
  }

  private bypassAutoSelect(group?: string, fault?: boolean) {
    if ((group === undefined || group === null || group === '') && !fault) { // no group or fault - clear selection
      this.bypassZones = [];
      return;
    }
    this.zonesList.forEach(zone => {
      if (!zone.persistent && fault && (zone.state === 'open_circuit' || zone.state === 'short_circuit') && !this.isZoneByPassed(zone)) {
        this.togglePyPassZone(zone);
      }
      if (!zone.persistent && zone.group === group && !this.isZoneByPassed(zone)) {
         this.togglePyPassZone(zone);
      }
    });
  }

  private isZoneByPassed(zone: any) {
    const bypassedIndex = this.bypassZones.indexOf(zone.id);
    return bypassedIndex > -1? true : false;
  }

  private renderZoneSelector() {
    const selectors = [];
    if (this.troubleList.length > 0) {
      selectors.push(
        <lar-button
         onClick={() => this.bypassAutoSelect('', true)}
         color="danger"
         size="small"
         class="zone-group"
         expand="block"
         outline
        >
           <lar-translate t="area.faultedOrTampered" />
        </lar-button>
       );
    }
    const filteredZones = this.zonesList.filter(z => !z.persistent && z.group !== '');
    const allGroups = map(filteredZones, 'group');
    const groups = uniq(allGroups);
    groups.forEach(group => {
      if (group === null || group === undefined) {
        return;
      }
      selectors.push(
         <lar-button
           color={this.color}
           onClick={() => this.bypassAutoSelect(group)}
           size="small"
           expand="block"
           class="zone-group"
           outline
         >
           <lar-translate t={(group || '<no name>')} />
         </lar-button>
       );
    });

    selectors.push(
       <lar-button
         color="warning"
         onClick={() => this.bypassAutoSelect()}
         size="small"
         class="zone-group"
         expand="block"
         outline
       >
           <lar-translate t="area.clearSelection" />
       </lar-button>
     );
    return selectors;
  }

  private partialarm() {
    if (this.modal) {
      this.modal.dismiss();
    }
    this.output.emit({ command: 'arm', override_zones: this.bypassZones, override_troubles: this.troubleList.length > 0 });
  }

  render() {
    const zones: any[] = [];
    this.zonesList = sortBy(JSON.parse(this.zones), 'group');
    this.troubleList = JSON.parse(this.troubles);
    const groupedZones = groupBy(this.zonesList, 'group');
    forOwn(groupedZones, (groupedZonesOwn, group) => {
      zones.push(<lar-list-header><lar-translate t={group} /></lar-list-header>);
      sortBy(groupedZonesOwn, 'name').forEach(zone => {
        let color = 'success';
        if (zone.state === 'open') {
          color = 'tertiary';
        }
        if (zone.state === 'short_circuit') {
          color = 'warning';
        }
        if (zone.state === 'open_circuit') {
          color = 'danger';
        }
        zones.push(
          <lar-list-item
          disabled={this.isZoneByPassed(zone)}
          onClick={() => { this.togglePyPassZone(zone); }}
          style={{ cursor:'pointer' }}
          >
            <div slot="start" class="circle">
              <lar-icon icon={zone.type} color={color} />
            </div>
            <div>
              <h4>
                <lar-translate t={zone.name} />
              </h4>
              <lar-badge color={color}>
                <lar-translate t={'area.zone_state.' + zone.state} />
              </lar-badge>
              {zone.overridden &&
                <span>&nbsp;<lar-badge color="danger"><lar-translate t={'area.zone_state.bypassed'} /></lar-badge></span>
              }
            </div>
          </lar-list-item>
        );
      });
    });
    return [
      <h4 class="center">{this.troubleList.length > 0
        ?
          <lar-translate
            t="area.overrideTroblesZonesInfo"
            values={{ troubles: this.troubleList.length > 0 ? this.troubleList.length:'0', zones: this.bypassZones.length >0 ? this.bypassZones.length : '0' }}
          />
        :
          <lar-translate
            t="area.overrideZonesInfo"
            values={{ zones: this.bypassZones.length > 0 ?this.bypassZones.length:'0' }}
          />
        }</h4>,
      <div class="spacer" />,
      <lar-button
        onClick={() => this.partialarm()}
        color={this.color}
      >
        <lar-icon icon={this.bypassZones.length > 0 ? 'halflock' : 'lock'} />&nbsp;
        <lar-translate
          t={
            this.troubleList.length > 0 ?
            this.bypassZones.length > 0 ? 'area.overridePartialArm' : 'area.overridearm'
            :
            this.bypassZones.length > 0 ? 'area.partialarm' : 'area.arm'
          }
        />
      </lar-button>,
      <div class="spacer" />,
      <div class="zone-selectors">
        {this.renderZoneSelector()}
      </div>,
      <div class="zone-list">{zones}</div>
    ];
  }
}